import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import type {
  DepartmentDetailsResponse,
  DepartmentsResponse,
} from 'src/queries/organizations/department.queries'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getDepartments = async (
  organizationId: string,
  includeArchived: boolean,
): Promise<DepartmentsResponse> =>
  getResponseData(
    axios.get<DepartmentsResponse>(
      `/organizations/${organizationId}/departments?includeArchived=${includeArchived}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getDepartmentDetails = async (
  organizationId: string,
  departmentId: string,
): Promise<{ department: DepartmentDetailsResponse }> =>
  getResponseData(
    axios.get<{ department: DepartmentDetailsResponse }>(
      `/organizations/${organizationId}/departments/${departmentId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
